import React from 'react';
import styles from './RadioButton.module.sass';

const RadioButton = ({
    groupId,
    label,
    isDisabled, isActive,
    onChange
}: Props) => {
    return <label
        className={`${styles['radiobutton']} ${isDisabled ? styles['radiobutton--disabled'] : ''}`}
    >
        <div className={styles['radiobutton__background']}>
            <input type="radio" name={groupId} checked={isActive} onChange={(e) => isDisabled ? {} : onChange(e.target.value)} />
        </div>
        { label }
    </label>;
}

interface Props {
    groupId?: any
    id?: any
    label: any
    isActive?: any
    isDisabled?: any
    onChange?: any
}

export default RadioButton;